import axios from 'axios';

const appBasePath = (import.meta.env.VITE_APP_BASE_PATH || '').replace(/\/$/, '');

const csrfClient = axios.create({
  baseURL: appBasePath || '/',
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
});

const api = axios.create({
  baseURL: appBasePath + '/api',
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
});

let csrfReady = false;

export async function ensureCsrfCookie() {
  if (!csrfReady) {
    await csrfClient.get('/sanctum/csrf-cookie');
    csrfReady = true;
  }
}

api.interceptors.request.use(async (config) => {
  const method = (config.method || 'get').toLowerCase();
  if (['post', 'put', 'patch', 'delete'].includes(method)) {
    await ensureCsrfCookie();
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config || {};

    if (error.response?.status === 419 && !originalRequest.__csrfRetry) {
      csrfReady = false;
      originalRequest.__csrfRetry = true;
      await ensureCsrfCookie();
      return api(originalRequest);
    }

    if (error.response?.status === 401) {
      const currentPath = appBasePath && window.location.pathname.startsWith(appBasePath)
        ? window.location.pathname.slice(appBasePath.length) || '/'
        : window.location.pathname;
      const publicPaths = ['/login', '/register'];
      if (!publicPaths.includes(currentPath)) {
        window.location.href = `${appBasePath}/login`;
      }
    }

    return Promise.reject(error);
  }
);

export default api;
